import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

export default function CookieConsent() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cwc_cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setShow(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cwc_cookie_consent', 'accepted');
    setShow(false);
  };

  const decline = () => {
    localStorage.setItem('cwc_cookie_consent', 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-14 left-3 right-3 md:left-auto md:right-6 md:max-w-sm z-50 bg-white rounded-xl shadow-2xl border border-gray-200 p-3 md:p-5 animate-fadeInUp" data-testid="cookie-consent-banner">
      <div className="flex items-start gap-2 mb-2">
        <Cookie className="w-4 h-4 text-cwc-navy shrink-0 mt-0.5" />
        <p className="text-xs text-gray-600 leading-relaxed">
          We use cookies to improve your experience. <Link to="/cookie-policy" className="text-red-600 underline font-medium">Learn more</Link>
        </p>
      </div>
      <div className="flex gap-2 justify-end">
        <button onClick={decline} className="text-xs text-gray-400 hover:text-gray-600 px-3 py-1.5 transition-colors" data-testid="cookie-decline">Decline</button>
        <button onClick={accept} className="bg-cwc-navy text-white text-xs font-bold px-4 py-1.5 rounded-lg hover:bg-cwc-navy-light transition-colors" data-testid="cookie-accept">Accept</button>
      </div>
    </div>
  );
}
